module.exports = __webpack_public_path__ + "static/bg-mountains-55fdd7f9ea1cfcbea3b5e5e12a48d3b4.png";